var ThemeBreakpointIndexEnum;
(function (ThemeBreakpointIndexEnum) {
    ThemeBreakpointIndexEnum[ThemeBreakpointIndexEnum["small"] = 0] = "small";
    ThemeBreakpointIndexEnum[ThemeBreakpointIndexEnum["medium"] = 1] = "medium";
    ThemeBreakpointIndexEnum[ThemeBreakpointIndexEnum["large"] = 2] = "large";
    ThemeBreakpointIndexEnum[ThemeBreakpointIndexEnum["xlarge"] = 3] = "xlarge";
    ThemeBreakpointIndexEnum[ThemeBreakpointIndexEnum["xxlarge"] = 4] = "xxlarge"; // Kiosk size
})(ThemeBreakpointIndexEnum || (ThemeBreakpointIndexEnum = {}));
export default ThemeBreakpointIndexEnum;
//# sourceMappingURL=ThemeBreakpointIndexEnum.js.map